module.exports = __webpack_public_path__ + "img/hn_thumb.424683ad.png";